module.exports = __webpack_public_path__ + "static/media/data-management.66d02b85.svg";